import apiClient from './apiClient'


const getLabels = (tenant) => {
  return apiClient.get(`/${tenant}/Event/Labels`)
}

const createLabel = (tenant, label) => {
  return apiClient.post(`/${tenant}/Event/Label`, label)
}

const updateLabel = (tenant, id, label) => {
  return apiClient.put(`/${tenant}/Event/Label/${id}`, label)
}

const deleteLabel = (tenant, id) => {
  return apiClient.delete(`/${tenant}/Event/Label/${id}`)
}


export default {
  getLabels,
  createLabel,
  updateLabel,
  deleteLabel
}
